import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import PropsChecker from '@core-front/props-checker';
import { AccordionContext, } from './accordion';
const AccordionCore = (props) => {
    const getContent = () => {
        if (props.disableAnalyticsTrigger) {
            return React.createElement(AccordionCoreInner, Object.assign({}, props));
        }
        return (React.createElement(AnalyticsTrigger, { trigger: [
                {
                    callback: 'onOpen',
                    id: ([id]) => {
                        return `Accordion - ${id}`;
                    },
                    elementId: ([id]) => {
                        return `${id}`;
                    },
                    elementType: 'accordion',
                    interactionType: 'open',
                },
                {
                    callback: 'onClose',
                    id: ([id]) => {
                        return `Accordion - ${id}`;
                    },
                    elementId: ([id]) => {
                        return `${id}`;
                    },
                    elementType: 'accordion',
                    interactionType: 'close',
                },
            ] },
            React.createElement(AccordionCoreInner, Object.assign({}, props))));
    };
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "Accordion", defaultValueName: "defaultOpenItem", valueName: "openItem", onChangeNames: "onToggle" }, getContent()));
};
class AccordionCoreInner extends React.Component {
    static getOpenItems(items) {
        return (Array.isArray(items) ? items : (items ? [items] : []));
    }
    constructor(props) {
        super(props);
        this.setOpenItems = (id, isOpen) => {
            const openItems = this.getNewOpenItems(id, isOpen);
            if (!this.isControlled) {
                this.setState({ openItems });
            }
            if (this.props.onToggle && !this.props.multiple) {
                this.props.onToggle(openItems.length ? openItems[0] : null);
            }
            else if (this.props.onToggle && this.props.multiple) {
                this.props.onToggle(openItems);
            }
            if (isOpen && this.props.onOpen) {
                this.props.onOpen(id);
            }
            else if (this.props.onClose) {
                this.props.onClose(id);
            }
        };
        this.state = {
            openItems: AccordionCoreInner.getOpenItems(props.defaultOpenItem),
        };
    }
    get isControlled() {
        return typeof this.props.openItem !== 'undefined';
    }
    get openItems() {
        return this.isControlled ? AccordionCoreInner.getOpenItems(this.props.openItem) : this.state.openItems;
    }
    BEM() {
        const classArray = ['accordion'];
        if (this.props.size) {
            classArray.push('accordion--' + this.props.size);
        }
        if (this.props.bordered) {
            classArray.push('accordion--bordered');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getNewOpenItems(id, isOpen) {
        const openItems = this.openItems;
        if (!isOpen) {
            return openItems.filter((i) => i !== id);
        }
        else if (isOpen && this.props.multiple) {
            return [...openItems, id];
        }
        else if (isOpen) {
            return [id];
        }
        return [];
    }
    render() {
        const accordionContextValue = {
            openItems: this.openItems,
            setOpenItems: this.setOpenItems,
        };
        return (React.createElement(AccordionContext.Provider, { value: accordionContextValue },
            React.createElement("div", { className: this.BEM() }, this.props.children)));
    }
}
AccordionCoreInner.defaultProps = {
    bordered: true,
};
export default AccordionCore;
